<div class="row">
  @if (noPaymentsMade) {
    <div class="row pad-bottom-20">
      <div class="float-left" dsContent [contentPath]="'claims.noPaymentsDeterminedText'"></div>
    </div>
  } @else {
    @for (transaction of firstPartyPaymentTransactions; track transaction) {
      <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
        <div class="float-left">
          <strong>{{ transaction.payee }}</strong>
        </div>
        <div class="float-right">
          <div>{{ transaction.amount | currencyUSD }}</div>
          <div>{{ transaction.trasactedOn | dateOutFormat }}</div>
        </div>
      </div>
    }
  }
</div>
<!--
<div class="row pad-bottom-20 pad-top-20" *ngIf="thirdPartyIndicator">
  <div class="row">
    <div class="float-left">
      <strong>Third-party payments</strong>
    </div>
    <div class="float-right">
      <span>Yes</span>
    </div>
  </div>
  <div class="row">
    <span>Third-party payments may include payments to other drivers, passengers, etc.</span>
  </div>
</div>
-->
